import { Sparkles } from 'lucide-react'
import EsmaList from '../components/esma/EsmaList'

export default function Esma() {
  return (
    <div className="p-6">
      {/* Header */}
      <div className="mb-6">
        <div className="flex items-center gap-3 mb-2">
          <Sparkles size={32} style={{ color: 'var(--primary-color)' }} />
          <h1 className="text-3xl font-bold" style={{ color: 'var(--text-primary)' }}>
            99 Esma
          </h1>
        </div>
        <p style={{ color: 'var(--text-secondary)' }}>
          Maneviyat kategorisi uzmanlari - Proje danismanligi icin
        </p>
      </div>

      {/* Esma listesi */}
      <EsmaList />
    </div>
  )
}
